/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserRolePermissionDto } from '../../models/user-role-permission-dto';

export interface GetRolesPermissions$Params {
}

export function getRolesPermissions(http: HttpClient, rootUrl: string, params?: GetRolesPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserRolePermissionDto>>> {
  const rb = new RequestBuilder(rootUrl, getRolesPermissions.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserRolePermissionDto>>;
    })
  );
}

getRolesPermissions.PATH = '/api/user/roles';
